/**
 * useBookingNavigation Hook
 * Step navigation logic
 */

import { useState, useCallback } from 'react';
import { BookingStep } from '../utils/bookingConstants';
import { getNextStep, getPreviousStep } from '../utils/bookingStepConfig';

export function useBookingNavigation(initialStep: BookingStep = 'select-person') {
  const [currentStep, setCurrentStep] = useState<BookingStep>(initialStep);

  const goForward = useCallback(() => {
    const nextStep = getNextStep(currentStep);
    if (nextStep) {
      setCurrentStep(nextStep);
    }
  }, [currentStep]);

  const goBackward = useCallback(
    (eventType: string | null) => {
      const prevStep = getPreviousStep(currentStep, eventType);
      if (prevStep) {
        setCurrentStep(prevStep);
      }
    },
    [currentStep]
  );

  const setStep = useCallback((step: BookingStep) => {
    setCurrentStep(step);
  }, []);

  return {
    currentStep,
    setStep,
    goForward,
    goBackward,
  };
}
